// Import HTTP client
import {
  getDashboardReportService,
  getYieldService,
  getCurrencyUpdateService
} from '@/services/reportService'

/** mutation types */
const set_dashboardReports = 'set_dashboardReports'
const set_usdBalance = 'set_usdBalance'
const set_usdcBalance = 'set_usdcBalance'
const set_yields = 'set_yields'
const set_currencyUpdates = 'set_currencyUpdates'
const set_currentCurrencyPair = 'set_currentCurrencyPair'
const set_accountDetailsCurrency = 'set_accountDetailsCurrency'
const set_frozenAccountBalances = 'set_frozenAccountBalances'

/** state */
const getDefaultState = () => {
  return {
    accountDetailsCurrency: '',
    dashboardReports: {},
    usdBalance: 0,
    usdcBalance: 0,
    yields: [],
    currentCurrencyPair: {
      fromCurrency: 'NGN',
      toCurrency: 'USD',
      page: 1,
      size: 5
    },
    currencyUpdates: {
      percentageChange: 0
    },
    frozenAccountBalances: []
  }
}
const state = getDefaultState()

/** mutations */
const mutations = {
  [set_dashboardReports] (state, data) {
    state.dashboardReports = data
  },
  [set_usdBalance] (state, data) {
    state.usdBalance = data
  },
  [set_usdcBalance] (state, data) {
    state.usdcBalance = data
  },
  [set_yields] (state, data) {
    state.yields = data
  },
  [set_currentCurrencyPair] (state, data) {
    state.currentCurrencyPair = data
  },
  [set_currencyUpdates] (state, data) {
    state.currencyUpdates = data
  },
  [set_accountDetailsCurrency] (state, data) {
    state.accountDetailsCurrency = data
  },
  [set_frozenAccountBalances] (state, data) {
    state.frozenAccountBalances = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  resetReportState ({ commit }) {
    commit('resetState')
  },
  setAccountDetailsCurrency: ({ commit }, payload) => {
    commit('set_accountDetailsCurrency', payload)
  },
  getDashboardReports: ({ commit }, payload) => {
    return getDashboardReportService(payload).then((response) => {
      commit('set_dashboardReports', response.data.data || {})
    })
  },
  getFrozenAccountBalances: ({ commit }, payload) => {
    return getDashboardReportService(payload).then((response) => {
      commit('set_frozenAccountBalances', response.data.data.balances || [])
    })
  },
  getCurrencyUpdates: ({ commit }, payload) => {
    return getCurrencyUpdateService(payload).then((response) => {
      commit('set_currentCurrencyPair', payload)
      commit('set_currencyUpdates', response.data.data || {})
    })
  },
  getYields: ({ commit }, payload) => {
    return getYieldService(payload).then((response) => {
      commit('set_yields', response.data.data.items || [])
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
